import { apiClient } from "./api";

/**
 * Register a new user
*/
export const registerUser = async (payload: any) => {
    const result = await apiClient.post<{
        message: string;
        data?: any;
    }>('/auth/register', payload);

    return result;
}


/**
 * Fetch all users
 */
export const getUsers = async () => {
    const result = await apiClient.post<any[]>('/auth/users', {});
    return result;
};


/**
 * Update user details.
 */
export const updateUser = async (payload: any) => {
    const result = await apiClient.post<{
        message: string;
        data?: any;
    }>('/auth/update', payload);

    return result;
};